import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['image', 'input']

  static values = {
    rotation: { default: 0, type: Number },
  }

  rotateLeft() {
    this.rotationValue = (this.rotationValue - 90) % 360
  }

  rotateRight() {
    this.rotationValue = (this.rotationValue + 90) % 360
  }

  rotationValueChanged() {
    this.inputTarget.value = this.rotationValue
    this.imageTarget.style.transform = `rotate(${this.rotationValue}deg)`
  }
}
